import energy from './energy.png';
import communication from './communication.png';
import illumination from './illumination.png';
import traffic from './traffic.png';
import transportation from './transportation.png';
import parking from './parking.png';
import solid_waste from './solid_waste.png';
import water from './water.png';
import info from './info.png';
import emergency from './emergency.png';
import environment from './environment.png';
import public_space from './publicSpace.png';

export {
    info,
    energy,
    parking,
    solid_waste,
    water,
    communication,
    illumination,
    traffic,
    transportation,
    emergency,
    environment,
    public_space
};